import React, { createContext, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

const NavigationGuardContext = createContext(null);

export function NavigationGuardProvider({ children }) {
  const navigate = useNavigate();
  const guardRef = useRef(null);

  const registerGuard = (fn) => {
    guardRef.current = fn;
    return () => {
      if (guardRef.current === fn) guardRef.current = null;
    };
  };

  const guardedNavigate = async (to) => {
    if (guardRef.current) {
      const allowed = await guardRef.current(to);
      if (!allowed) return;
    }
    navigate(to);
  };

  return (
    <NavigationGuardContext.Provider value={{ registerGuard, guardedNavigate }}>
      {children}
    </NavigationGuardContext.Provider>
  );
}

export function useNavigationGuard() {
  const ctx = useContext(NavigationGuardContext);
  if (!ctx) {
    throw new Error(
      "useNavigationGuard must be used inside NavigationGuardProvider"
    );
  }
  return ctx;
}
